import React, { useState } from 'react'
import { IconButton } from '@mui/material'
import { Link } from 'react-router-dom'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import LocalAtmIcon from '@mui/icons-material/LocalAtm'
import ListAltIcon from '@mui/icons-material/ListAlt'
import FlutterDashIcon from '@mui/icons-material/FlutterDash'
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation'
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import { useAuth } from "../api/authStore"
import { loginUrl } from '../config/config'
import PaymentDialog from '../PaymentDialog'
import ThemeToggle from './ThemeToggle'
import logo from '../img/landing-logo.png'

const MobileMenu = ({ user, active, apiClient, isOpen, onClose }) => {
  const { logout } = useAuth()
  const [openPaymentDialog, setOpenPaymentDialog] = useState(false)
  const [showHelpModal, setShowHelpModal] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)
  const [shouldRender, setShouldRender] = useState(false)
  
  const accountEmail = user?.username || ''
  const balance = user?.balance ? (user.balance/100).toFixed(2) : '0.00'
  const activeProxiesCount = active?.rentals?.length || 0

  // Логирование только в режиме разработки
  React.useEffect(() => {
    if (user?.username && process.env.NODE_ENV === 'development') {
    }
  }, [user?.username])

  // Управление анимациями открытия/закрытия
  React.useEffect(() => {
    if (isOpen) {
      setShouldRender(true)
      setIsAnimating(true)
    } else {
      setIsAnimating(false)
      const timer = setTimeout(() => {
        setShouldRender(false)
      }, 300) // Время анимации закрытия
      return () => clearTimeout(timer)
    }
  }, [isOpen])

  const handleLogout = (e) => {
    if (e) {
      e.preventDefault()
    }
    logout(loginUrl)
  }

  const handleOpenPaymentDialog = () => {
    setOpenPaymentDialog(true)
  }

  const handleHelpClick = (e) => {
    if (e) {
      e.preventDefault()
    }
    setShowHelpModal(true)
  }

  if (!shouldRender) return null

  return (
    <>
      <div 
        className={`mobile-menu-backdrop-${isAnimating ? 'enter' : 'exit'}`}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 1000
        }}
        onClick={onClose}
      />
      
      <div 
        className={`mobile-menu mobile-menu-${isAnimating ? 'enter' : 'exit'}`}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '280px',
          height: '100vh',
          background: showHelpModal ? 'var(--black)' : 'var(--dark-gray)',
          borderRight: '1px solid var(--light-gray)',
          zIndex: 1001,
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          opacity: showHelpModal ? 0.3 : 1,
          transition: 'opacity 0.3s ease'
        }}>
        {/* Заголовок */}
        <div style={{
          padding: 'var(--spacing-lg)',
          borderBottom: '1px solid var(--light-gray)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h1 style={{
            fontSize: 'var(--text-lg)',
            fontWeight: '700',
            background: 'var(--gradient-orange)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            margin: 0
          }}>
            {process.env.REACT_APP_NAME}
          </h1>
          <IconButton
            onClick={onClose}
            sx={{
              color: 'var(--text-light)',
              padding: '4px'
            }}
          >
            <ArrowBackIosNewOutlinedIcon fontSize="medium" />
          </IconButton>
        </div>

        {/* Профиль пользователя */}
        <div style={{
          padding: 'var(--spacing-lg)',
          borderBottom: '1px solid var(--light-gray)',
          background: 'var(--medium-gray)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: 'var(--spacing-sm)'
          }}>
            <img 
              src={logo} 
              alt="Logo" 
              style={{
                width: '32px',
                height: '32px',
                marginRight: 'var(--spacing-sm)'
              }} 
            />
            <div style={{ flex: 1 }}>
              <div style={{
                fontSize: 'var(--text-sm)',
                fontWeight: '600',
                color: 'var(--text-light)',
                marginBottom: 'var(--spacing-xs)'
              }}>
                <Link 
                  to='/account' 
                  style={{
                    color: 'var(--text-light)',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    transition: 'color 0.2s ease',
                    display: 'inline-block'
                  }}
                  onClick={onClose} // Закрываем меню при клике
                  onMouseEnter={(e) => {
                    e.target.style.color = 'var(--primary-orange)'
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'var(--text-light)'
                  }}
                >
                  {accountEmail.replace(/(.{15})..+/, "$1…")}
                </Link>
              </div>
              <div style={{
                fontSize: 'var(--text-xs)',
                color: 'var(--text-muted)',
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--spacing-sm)'
              }}>
                <span>Balance: <strong style={{ color: 'var(--primary-orange)' }}>${balance}</strong></span>
                <button
                  onClick={handleOpenPaymentDialog}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#00B24A',
                    fontSize: 'var(--text-xs)',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    padding: 0
                  }}
                >
                  Add Funds
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Навигационное меню */}
        <div style={{ flex: 1, padding: 'var(--spacing-md) 0' }}>
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.1s' }}>
            <MobileNavItem 
              icon={LocalGasStationIcon} 
              label="Proxies Store" 
              href="/proxies"
            />
          </div>
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.15s' }}>
            <MobileNavItem 
              icon={FlutterDashIcon} 
              label={`Active Proxies${activeProxiesCount > 0 ? ` (${activeProxiesCount})` : ''}`} 
              href="/active"
            />
          </div>
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.2s' }}>
            <MobileNavItem 
              icon={LocalAtmIcon} 
              label="Transactions" 
              href="/transactions"
            />
          </div>
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.25s' }}>
            <MobileNavItem 
              icon={AccessTimeIcon} 
              label="History" 
              href="/history"
            />
          </div>
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.3s' }}>
            <MobileNavItem 
              icon={ListAltIcon} 
              label="Tickets" 
              href="/tickets"
            />
          </div>
        </div>

        {/* Нижняя секция */}
        <div style={{
          padding: 'var(--spacing-md)',
          borderTop: '1px solid var(--light-gray)',
          background: 'var(--black)'
        }}>
          {/* Переключатель тем */}
          <div className="mobile-menu-item-enter" style={{ 
            animationDelay: '0.35s',
            marginBottom: 'var(--spacing-sm)'
          }}>
            <ThemeToggle />
          </div>
          
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.4s' }}>
            <MobileNavItem 
              icon={PsychologyAltIcon} 
              label="Help" 
              href="#"
              onClick={handleHelpClick}
            />
          </div>
          <div className="mobile-menu-item-enter" style={{ animationDelay: '0.45s' }}>
            <MobileNavItem 
              icon={PowerSettingsNewIcon} 
              label="Logout" 
              href="#"
              onClick={handleLogout}
            />
          </div>
        </div>
      </div>

      <PaymentDialog 
        open={openPaymentDialog} 
        setOpentPaymentDialog={setOpenPaymentDialog} 
        apiClient={apiClient}
      />
      
      <HelpModal 
        isOpen={showHelpModal} 
        onClose={() => {
          setShowHelpModal(false)
        }}
      />
    </>
  )
}

const MobileNavItem = ({ icon: Icon, label, href, onClick }) => {
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault()
      onClick(e)
    }
  }

  const handleTouchStart = (e) => {
    // Предотвращаем выделение текста
    e.preventDefault()
    // Добавляем визуальную обратную связь при touch
    e.target.style.backgroundColor = 'var(--medium-gray)'
    e.target.style.color = 'var(--primary-orange)'
    e.target.style.transform = 'scale(0.98)'
  }

  const handleTouchEnd = (e) => {
    // Убираем визуальную обратную связь после touch
    setTimeout(() => {
      e.target.style.backgroundColor = 'transparent'
      e.target.style.color = 'var(--text-light)'
      e.target.style.transform = 'scale(1)'
    }, 150)
  }

  const handleTouchCancel = (e) => {
    // Сбрасываем стили при отмене touch
    e.target.style.backgroundColor = 'transparent'
    e.target.style.color = 'var(--text-light)'
    e.target.style.transform = 'scale(1)'
  }

  return (
    <a 
      href={href} 
      onClick={handleClick}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchCancel={handleTouchCancel}
      className="mobile-nav-item"
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: 'var(--spacing-md) var(--spacing-lg)',
        margin: 'var(--spacing-xs) var(--spacing-sm)',
        borderRadius: 'var(--radius-md)',
        color: 'var(--text-light)',
        textDecoration: 'none',
        transition: 'all 0.2s ease',
        backgroundColor: 'transparent',
        transform: 'scale(1)'
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = 'var(--medium-gray)'
        e.target.style.color = 'var(--primary-orange)'
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = 'transparent'
        e.target.style.color = 'var(--text-light)'
      }}
    >
      <Icon style={{ 
        fontSize: '20px', 
        marginRight: 'var(--spacing-md)',
        color: 'var(--primary-orange)'
      }} />
      <span style={{
        fontSize: 'var(--text-sm)',
        fontWeight: '500'
      }}>
        {label}
      </span>
    </a>
  )
}

// Компонент модального окна с контактными данными
const HelpModal = ({ isOpen, onClose }) => {
  
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  // Обработка клавиши Escape
  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      return () => document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10002
    }} onClick={handleBackdropClick}>
      <div style={{
        background: 'var(--medium-gray)',
        border: '1px solid var(--light-gray)',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--spacing-xl)',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '80vh',
        overflowY: 'auto',
        boxShadow: 'var(--shadow-card)',
        position: 'relative',
        margin: 'var(--spacing-md)'
      }} onClick={(e) => e.stopPropagation()}>
        {/* Кнопка закрытия */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 'var(--spacing-md)',
            right: 'var(--spacing-md)',
            color: 'var(--text-muted)',
            padding: '4px'
          }}
        >
          <ArrowBackIosNewOutlinedIcon fontSize="medium" />
        </IconButton>

        {/* Заголовок */}
        <h2 style={{
          color: 'var(--text-light)',
          fontSize: 'var(--text-2xl)',
          fontWeight: '700',
          marginBottom: 'var(--spacing-lg)',
          textAlign: 'center',
          background: 'var(--gradient-orange)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          Technical Support
        </h2>

        {/* Контактная информация */}
        <div style={{ marginBottom: 'var(--spacing-lg)' }}>
          <div style={{
            background: 'var(--dark-gray)',
            border: '1px solid var(--light-gray)',
            borderRadius: 'var(--radius-md)',
            padding: 'var(--spacing-lg)',
            marginBottom: 'var(--spacing-md)'
          }}>
            <h3 style={{
              color: 'var(--primary-orange)',
              fontSize: 'var(--text-lg)',
              marginBottom: 'var(--spacing-md)',
              fontWeight: '600'
            }}>
              📧 Email Support
            </h3>
            <p style={{
              color: 'var(--text-light)',
              fontSize: 'var(--text-base)',
              marginBottom: 'var(--spacing-sm)'
            }}>
              <strong>xsocks@yahoo.com</strong>
            </p>
            <p style={{
              color: 'var(--text-muted)',
              fontSize: 'var(--text-sm)',
              lineHeight: '1.5'
            }}>
              Send us an email with your question or issue. We typically respond within 24 hours.
            </p>
          </div>

          <div style={{
            background: 'var(--dark-gray)',
            border: '1px solid var(--light-gray)',
            borderRadius: 'var(--radius-md)',
            padding: 'var(--spacing-lg)'
          }}>
            <h3 style={{
              color: 'var(--primary-orange)',
              fontSize: 'var(--text-lg)',
              marginBottom: 'var(--spacing-md)',
              fontWeight: '600'
            }}>
              💬 Telegram Support
            </h3>
            <p style={{
              color: 'var(--text-light)',
              fontSize: 'var(--text-base)',
              marginBottom: 'var(--spacing-sm)'
            }}>
              <a 
                href="https://t.me/xsocks_support" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  color: 'var(--primary-orange)',
                  textDecoration: 'none',
                  fontWeight: '600'
                }}
                onMouseEnter={(e) => {
                  e.target.style.textDecoration = 'underline'
                  e.target.style.color = 'var(--light-orange)'
                }}
                onMouseLeave={(e) => {
                  e.target.style.textDecoration = 'none'
                  e.target.style.color = 'var(--primary-orange)'
                }}
              >
                @xsocks_support
              </a>
            </p>
            <p style={{
              color: 'var(--text-muted)',
              fontSize: 'var(--text-sm)',
              lineHeight: '1.5'
            }}>
              Get instant help through our Telegram support channel. Available for quick assistance.
            </p>
          </div>
        </div>

        {/* Кнопка закрытия */}
        <div style={{ textAlign: 'center' }}>
          <button
            onClick={onClose}
            className="btn btn-primary"
            style={{ minWidth: '120px' }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

export default MobileMenu
